import React from 'react';
import {useSelector} from "react-redux";
import {useConfirmCompanyInviteMutation, useValidateCompanyInviteTokenQuery} from "apis/companiesApi";
import AuthLayout from "layouts/AuthLayout";
import { Button } from 'primereact/button';
import {useNavigate} from "react-router-dom";

const CompanyInvitationConfirmationPage = () => {
    const token = useSelector(state => state.authentication.inviteToken);
    const {error, isFetching} = useValidateCompanyInviteTokenQuery({token});
    const [confirmCompanyInvite] = useConfirmCompanyInviteMutation();
    const navigate = useNavigate();

    const onClickConfirmCompanyInvite = (accept) => {
        confirmCompanyInvite({token, accept});

        navigate('/');
    }

    return (
        <AuthLayout>
            <div className="company-invitation-confirmation-page">
                {isFetching ? (
                    <>Validating...</>
                ) : error ? (
                    <>{error.data?.message || "System error occurred.  Please try again later"}</>
                ) : (
                    <>
                        <h5>Welcome to the BusinessScape Management Platform.  Please confirm you are accessing your personal dashboard for the first time.</h5>
                        <div className="button-panel">
                            <Button label="Confirm" icon="pi pi-check" className="p-button-success" onClick={() => onClickConfirmCompanyInvite(true)} />
                            <Button label="Decline" icon="pi pi-times" className="p-button-danger" onClick={() => onClickConfirmCompanyInvite(false)} />
                        </div>
                    </>
                )}
            </div>
        </AuthLayout>);
}

export default CompanyInvitationConfirmationPage;
